var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13, 11) scale(0.035)",
    fill: "#033476"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.776 422.378H26.399C11.819 422.378 0 410.559 0 395.979s11.819-26.399 26.399-26.399h422.378c14.58 0 26.399 11.82 26.399 26.399s-11.82 26.399-26.4 26.399zm-211.189-158.391H26.399C11.819 263.987 0 252.167 0 237.588c0-14.58 11.819-26.399 26.399-26.399h211.189c14.58 0 26.399 11.819 26.399 26.399 0 14.579-11.82 26.399-26.4 26.399zm211.189-158.392H26.399C11.819 105.595 0 93.776 0 79.197s11.819-26.399 26.399-26.399h422.378c14.58 0 26.399 11.819 26.399 26.399S463.356 105.595 448.776 105.595z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenus);
export default __webpack_public_path__ + "static/media/menus.fb79145bbfd610b5e861feefdb29fcd9.svg";
export { ForwardRef as ReactComponent };